import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { memo } from 'react';

const ActionIconButton = styled(IconButton)<IconButtonProps>(({ theme }) => ({
  background: 'rgba(245, 246, 247, 0.60)',
  backdropFilter: 'blur(20px)',

  '&:hover': {
    background: theme.palette.action.hover,
  },

  '&.MuiIconButton-sizeMedium': {
    fontSize: theme.spacing(3),
  },

  '&.MuiIconButton-sizeSmall': {
    fontSize: theme.spacing(2.75),
  },

  '.kmx-car-tile[data-size="small"] &': {
    background: 'transparent',
    backdropFilter: 'none',
  },
}));

export default memo(ActionIconButton);
